import { ofType } from 'redux-observable';
import { EMPTY, from, NEVER, of, race, SchedulerLike } from 'rxjs';
import { catchError, filter, map, mergeMap, timeout, withLatestFrom } from 'rxjs/operators';
import { batchTradeAuthTimeout } from 'state/batchForm/batchForm.action';
import * as actionTypes from 'state/batchForm/batchForm.actionTypes';
import { batchTradeAuthReceivedThunk } from 'state/batchForm/batchForm.thunks';
import type { NextTradeAuthorizationResult } from 'state/quotes/trades/trades.model';
import type { EpicWithThunk } from 'state/state.common';
import { fatEventApiConnector } from 'utils/streaming/api';
import { tradeAuthorization } from 'utils/streaming/messages';

export function tradeAuthorizationEpic(scheduler?: SchedulerLike): EpicWithThunk {
  return (action$, state$, { oldHttpClient, getSgmeConfiguration, streaming }) =>
    action$.pipe(
      ofType(actionTypes.BATCH_QUOTE_ACKED),
      withLatestFrom(state$),
      mergeMap(([{ forms }, _]) => from(forms)),
      mergeMap(({ quoteId }) => {
        const tradeAuthTimeoutMs = getSgmeConfiguration().tradeAuthTimeoutMs;

        const tradeAuth$ = tradeAuthorization(streaming).pipe(
          filter(tradeAuth => tradeAuth.quoteId === quoteId),
          mergeMap(lightEvent =>
            fatEventApiConnector(oldHttpClient)
              .getFatEvent<NextTradeAuthorizationResult>(lightEvent)
              .pipe(catchError(_ => EMPTY)),
          ),
          map(tradeAuth => batchTradeAuthReceivedThunk(quoteId, tradeAuth)),
        );

        const timeout$ = NEVER.pipe(
          timeout({ each: tradeAuthTimeoutMs, with: () => of(batchTradeAuthTimeout(quoteId)), scheduler }),
        );
        return race([tradeAuth$, timeout$]);
      }),
    );
}
